<div
  class="fixed left-0 right-0 z-[90] flex flex-col bg-primary"
  [style.top.px]="viewportTop()"
  [style.height.px]="viewportHeight()">
  <div
    class="flex items-center h-14 px-4 border-b border-secondary touch-none"
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)">
    <button
      type="button"
      class="flex items-center gap-2 text-primary"
      aria-label="Back"
      (click)="onCancel()">
      <svg-icon src="assets/svg/arrow-left.svg" svgClass="w-5 h-5" />
      <span class="text-sm font-medium">Back</span>
    </button>
    <span class="ml-3 text-base font-semibold">Select: {{ title() }}</span>
  </div>

  <div class="flex items-center h-12 px-4 border-b border-secondary">
    <svg-icon
      src="assets/svg/search-sm.svg"
      svgClass="w-5 h-5"
      aria-hidden="true" />
    <input
      #searchInput
      type="search"
      placeholder="Search"
      class="flex-1 ml-2 bg-transparent outline-none"
      (input)="onSearchInput($event)" />
  </div>

  <div
    class="picker-options-list flex-1 min-h-0 overflow-y-auto overscroll-contain">
    @for (option of filteredOptions(); track option.value; let i = $index) {
      @if (option.group && option.group !== filteredOptions()[i - 1]?.group) {
        <div
          class="sticky top-0 px-4 py-2 bg-secondary text-secondary text-sm font-semibold"
          data-testid="picker-group-header">
          {{ option.group }}
        </div>
      }
      <button
        type="button"
        class="w-full px-4 py-3 text-left flex items-center"
        (click)="onOptionTap(option)">
        @if (multiple()) {
          <span
            class="app-dropdown-checkbox mr-2"
            [class.app-dropdown-checkbox-checked]="isSelected(option)"
            aria-hidden="true"></span>
        }
        <span>{{ option.label }}</span>
      </button>
    }
    @if (filteredOptions().length === 0) {
      <div class="px-4 py-8 text-center text-secondary">No results</div>
    }
  </div>

  @if (multiple()) {
    <div class="p-4 border-t border-secondary bg-primary">
      <app-button
        class="w-full"
        extraClasses="w-full"
        size="lg"
        [type]="ButtonType.Primary"
        text="Done"
        (clickEmitter)="onDone()" />
    </div>
  }
</div>
